/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { ScheduledOrdersConfigCreateRequest } from '../../models/scheduled-orders-config-create-request';
import { ScheduledOrdersConfigCreateResponse } from '../../models/scheduled-orders-config-create-response';

export interface UpsertScheduledOrdersConfiguration$Params {
  storeId: string;
  'Active-Tenant-Identifier': string;
      body: ScheduledOrdersConfigCreateRequest
}

export function upsertScheduledOrdersConfiguration(http: HttpClient, rootUrl: string, params: UpsertScheduledOrdersConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<ScheduledOrdersConfigCreateResponse>> {
  const rb = new RequestBuilder(rootUrl, upsertScheduledOrdersConfiguration.PATH, 'put');
  if (params) {
    rb.path('storeId', params.storeId, {});
    rb.header('Active-Tenant-Identifier', params['Active-Tenant-Identifier'], {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<ScheduledOrdersConfigCreateResponse>;
    })
  );
}

upsertScheduledOrdersConfiguration.PATH = '/stores/{storeId}/scheduled-orders';
